module.exports = __webpack_public_path__ + "img/quest.978c1a56.svg";